import useTheme from './useTheme';

const inThemedPage = () => (
  typeof document !== 'undefined'
    && !!document.body
    && document.body.classList.contains('od-themed')
);

const usePageColorScheme = () => {
  const { resolvedTheme } = useTheme();

  return inThemedPage() ? resolvedTheme : 'light';
};

export default usePageColorScheme;
